// import { httpClient } from "@/app/old/desktop/shared/services/";
import { BaseService } from "@/app/old/desktop/shared/services/";

const URL = "tags";

class API extends BaseService {
  constructor() {
    super(null, URL);
  }
}
export const ticketTagsService = new API();
